import { SignatureConfiguration } from "./signature-configuration";

export class SignatureGroup {

    id: number = 0;
    description!: string;
    signatureConfigurations: SignatureConfiguration[] = [];
    active: boolean = false;
    
}